import React from 'react';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { services } from '../data/services';
export const Services: React.FC = () => {
  return <div className="w-full bg-white py-20 md:py-24" data-id="element-775" data-mp="1dtj1tghdno1h">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-776" data-mp="1dw5c3nvnkhne">
        <div className="max-w-3xl mb-14" data-id="element-777" data-mp="18ufxxzd4vnv3">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-778" data-mp="13vuxbytyz264">
            Wat we voor je kunnen doen
          </motion.h2>
          <p className="text-[#6B7280] text-lg leading-relaxed" data-id="element-779" data-mp="l5dh2tqbpz1n">
            Je hoeft niet alles af te nemen. De meeste ondernemers beginnen bij
            een website of bij hun vormgeving, en breiden pas uit als daar
            resultaat uit komt. Loop je vast in Excel of losse tools, dan
            bouwen we software op maat.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-780" data-mp="3b4r7thy1m7ys">
          {services.map((service, index) => {
          const Icon = service.icon;
          const isFeatured = index < 2;
          // CorePrint (extern) sluit de rij af over de volle breedte, zodat het
          // raster met zeven diensten evenwichtig blijft: 2 + 2, daarna 4 x 1.
          if (service.external) {
            return <motion.a key={service.title} href={service.link} target="_blank" rel="noopener noreferrer" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="group sm:col-span-2 lg:col-span-4 flex flex-col md:flex-row md:items-center gap-4 md:gap-6 rounded-2xl border border-gray-200 bg-white p-6 hover:border-[#004AC7] transition-colors duration-200" data-id="element-781" data-mp="3u193gag0is0b">
                  <div className="flex items-center justify-center rounded-xl bg-[#F7F8FA] text-[#004AC7] border border-gray-100 w-11 h-11 flex-shrink-0" data-id="element-782" data-mp="1grivfzzsbz4t">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-783" data-mp="1bsfno7sf7et5" />
                  </div>
                  <div className="flex-grow" data-id="element-784" data-mp="16v61r248pla2">
                    <h3 className="font-bold text-[#111827] text-lg mb-1" data-id="element-785" data-mp="11urqzcb97x8c">{service.title}</h3>
                    <p className="text-[#6B7280] text-sm leading-relaxed" data-id="element-786" data-mp="xswtyk0cw60d">{service.description}</p>
                  </div>
                  <span className="inline-flex items-center gap-1.5 text-[#004AC7] font-semibold text-sm flex-shrink-0 whitespace-nowrap" data-id="element-787" data-mp="sud7mihuos7h">
                    Naar coreprint.nl
                    <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-788" data-mp="2n7us1wmyl8ya" />
                  </span>
                </motion.a>;
          }
          return <motion.a key={service.title} href={service.link} target={service.external ? '_blank' : undefined} rel={service.external ? 'noopener noreferrer' : undefined} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: Math.min(index, 4) * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`group flex flex-col rounded-2xl border transition-colors duration-200 ${isFeatured ? 'lg:col-span-2 bg-[#F7F8FA] border-gray-200 p-8 hover:border-[#004AC7]' : 'bg-white border-gray-200 p-6 hover:border-[#004AC7]'}`} data-id="element-789" data-mp="2uqkl2dlgqrbf" data-mpi={index}>
                <div className={`flex items-center justify-center rounded-xl bg-white text-[#004AC7] border border-gray-100 mb-5 ${isFeatured ? 'w-14 h-14' : 'w-11 h-11'}`} data-id="element-790" data-mp="2ptlv878u16j1">
                  <Icon className={isFeatured ? 'h-7 w-7' : 'h-5 w-5'} aria-hidden="true" data-id="element-791" data-mp="50qq4bnrkct1" />
                </div>
                <h3 className={`font-bold text-[#111827] mb-2 ${isFeatured ? 'text-2xl' : 'text-lg'}`} data-id="element-792" data-mp="3leiwfacz6jy">
                  {service.title}
                </h3>
                <p className={`text-[#6B7280] leading-relaxed flex-grow ${isFeatured ? 'text-base mb-6' : 'text-sm mb-5'}`} data-id="element-793" data-mp="djlo60vac064">
                  {service.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-[#004AC7] font-semibold text-sm mt-auto" data-id="element-794" data-mp="mjh40izscjch">
                  {service.external ? 'Naar coreprint.nl' : `Bekijk ${service.title.toLowerCase()}`}
                  {service.external ? <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-795" data-mp="w8iig4qomsoc" /> : <ArrowRightIcon className="h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-200" aria-hidden="true" data-id="element-796" data-mp="rah39uwdndi5" />}
                </span>
              </motion.a>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-16 border-t border-gray-200 pt-10 flex flex-col md:flex-row md:items-center gap-8" data-id="element-797" data-mp="1196iffww2jup">
          <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden, de mascotte van Noord Digital" loading="lazy" className="w-24 h-24 object-contain flex-shrink-0" data-id="element-798" data-mp="1fvby1vhxjykf" />
          <div className="flex-grow" data-id="element-799" data-mp="15xpgt2d5ruxa">
            <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-800" data-mp="15yqsn9200lg2">
              Weet je niet waar je moet beginnen?
            </h3>
            <p className="text-[#6B7280] leading-relaxed" data-id="element-801" data-mp="s3y8fxb5yh35">
              In een gesprek van een half uur kijken we naar je huidige
              vindbaarheid en vertellen we wat we zouden aanpakken. Je zit
              daarna tot niets verplicht.
            </p>
          </div>
          <a href="#contact" className="inline-flex items-center justify-center bg-[#004AC7] hover:bg-[#003A9E] text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex-shrink-0" data-id="element-802" data-mp="n5wq5elkalsq">
            Plan een kennismaking
          </a>
        </motion.div>
      </div>
    </div>;
};